import { createSlice } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'

const initialAlert = {
    message: null,
    title: null,
    type: null,
    onDone: null,
    textOk: null,
    onCancel: null,
    textCancel: null,
}

const initialState = {
    open: false,
    alert: initialAlert,
}

const AlertSlice = createSlice({
    name: 'Alert',
    initialState,
    reducers: {
        changeOpen(state, { payload }) {
            state.open = payload
        },
        changeAlert(state, { payload }) {
            state.alert = payload
        },
    },
})

export const { actions } = AlertSlice
export default AlertSlice.reducer

export const useAlertActions = () => {
    const dispatch = useDispatch()

    const handleChangeOpen = open => {
        dispatch(actions.changeOpen(open))
        if (!open) {
            setTimeout(() => {
                handleChangeAlert(initialAlert)
            }, 300)
        }
    }

    const handleChangeAlert = data => {
        if (data?.type) {
            handleChangeOpen(true)
        }
        dispatch(actions.changeAlert(data))
    }

    return {
        handleChangeOpen,
        handleChangeAlert,
    }
}
